import React from 'react'
import classnames from 'classnames'
import PromoButton from '../../Various/PromoButton/PromoButton'
import { Button, Card } from '@headtrip/components-react'
import { getGradient } from '../../../templates/tutorialsBase'
import * as styles from './TutorialCtaCard.module.scss'
import { getCurrentCTA } from '../cta'

const TutorialCtaCard = ({ cta, headerImg }) => {
  const gradient = getGradient(headerImg)
  const currentCTA = getCurrentCTA(cta)
  const {
    preTitle,
    title,
    text,
    subtext,
    url,
    buttonText,
    code
  } = currentCTA

  let promoButton = null
  const hasPromoCode = typeof code !== 'undefined'
  const hasSubText = typeof subtext !== 'undefined'

  const textStyles = classnames(
    hasSubText && 'mb-2'
  )
  const containerStyles = classnames(
    'd-flex align-items-start justify-content-between flex-wrap',
    hasPromoCode && styles.ctaCard
  )

  if (hasPromoCode) {
    promoButton = <PromoButton code={code} />
  }

  return (
    <Card className={`box-gradient ${gradient.smallBox} p-3 text-white border-0`}>
      {preTitle &&
        <p className='text-gray-500 mb-0'>
          {preTitle}
        </p>}
      <h5 className='uppercase'>
        {title}
      </h5>
      <p className={textStyles}>{text}</p>
      {
        hasSubText && (
          <small
            className="mb-2"
            style={{ whiteSpace: 'pre-wrap' }}
          >
            {subtext}
          </small>
        )
      }
      <div
        className={containerStyles}
      >
        {promoButton}
        <Button
          className="mw-100"
          href={url}
          variant='primary'
          target="_blank"
        >
          {buttonText}
        </Button>
      </div>
    </Card>
  )
}

export default TutorialCtaCard
